import { render, staticRenderFns } from "./ReferredBy.vue?vue&type=template&id=18bd00f0"
import script from "./ReferredBy.vue?vue&type=script&lang=js"
export * from "./ReferredBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports